module.exports = __webpack_public_path__ + "img/legalxchain_position_img.815814a2.png";